import React, { Component } from "react";
import { connect } from "react-redux";
import Content from "../../content/Content";
import Store from "../../content/Store";
import { shouldShowIfAllSMEModulesDontMatch } from "../../helpers/SMEModules/smeModuleHelper";
// import NotificationsStatus from "../notifications/NotificationsStatus";
import HomeCard from "./HomeCard";
import {
  nonClaimsModules,
  travelOrEapModules
} from "../../constants/SMEModulesToMatchOn";
import {
  ButtonConfig
} from "../../constants/Constants";

export class NewCard extends Component {
  static content = Store.Home;

  GetMatchedImage(matches, imgSrcMobile, imgSrc) {
    return matches ? (
      <img src={imgSrcMobile} alt="" aria-hidden />
    ) : (
      <img src={imgSrc} alt="" aria-hidden />
    );
  }

  render() {
    return (
      <div className="row">
        <div
          className={
            "col-sm-12 " + (this.props.shouldShowClaims ? "col-lg-4" : "col-lg-6")
          }
          data-explore-my-cover-home-card
        >
          <Content
            names={[
              Store.Home.Cards.HomeMyCoverSrc.IconSrc,
              Store.Home.Cards.HomeMyCoverSrc.Heading,
              Store.Home.Cards.HomeMyCoverSrc.Description,
              Store.Home.Cards.HomeMyCoverSrc.LinkText,
              Store.Home.Cards.HomeMyCoverSrc.LinkTo,
              Store.Home.Cards.HomeMyCoverSrc.ExternalLinkTo
            ]}
          >
            {(
              iconSrc,
              heading,
              description,
              linkText,
              linkTo,
              externalLinkTo
            ) => (
              <HomeCard
                IconSrc={iconSrc}
                Heading={heading}
                Description={description}
                LinkText={linkText}
                LinkTo={linkTo}
                ExternalLinkTo={externalLinkTo}
                id={ButtonConfig.HomeIndcta_mol_hp_trco}
              />
            )}
          </Content>
        </div>       
        <div className="col-sm-12 col-lg-4" data-claims-home-card>
        <Content
          names={[
            Store.Home.Cards.HomeEAPpolicySrc.IconSrc,
            Store.Home.Cards.HomeEAPpolicySrc.Heading,
            Store.Home.Cards.HomeEAPpolicySrc.Description,
            Store.Home.Cards.HomeEAPpolicySrc.LinkText,
            Store.Home.Cards.HomeEAPpolicySrc.LinkTo,
            Store.Home.Cards.HomeEAPpolicySrc.ExternalLinkTo
            
          ]}
        >
          {(
            iconSrc,
            heading,
            description,
            linkText,
            linkTo,
            externalLinkTo
          ) => (
            <HomeCard
              IconSrc={iconSrc}
              Heading={heading}
              Description={description}
              LinkText={linkText}
              LinkTo={linkTo}
              ExternalLinkTo={externalLinkTo}
              id={ButtonConfig.HomeIndcta_mol_hp_docs}
            />
          )}
        </Content>
      </div> 
        <div
          className={
            "col-sm-12 " + (this.props.shouldShowClaims ? "col-lg-4" : "col-lg-6")
          }
          data-access-health-support-home-card
        >
          <Content
            names={[
              Store.Home.Cards.HomeClaimSrc.IconSrc,
              Store.Home.Cards.HomeClaimSrc.Heading,
              Store.Home.Cards.HomeClaimSrc.Description,
              Store.Home.Cards.HomeClaimSrc.LinkText,
              Store.Home.Cards.HomeClaimSrc.LinkTo,
              Store.Home.Cards.HomeClaimSrc.ExternalLinkTo
            ]}
          >
            {(
              iconSrc,
              heading,
              description,
              linkText,
              linkTo,
              externalLinkTo
            ) => (
              <HomeCard
                IconSrc={iconSrc}
                Heading={heading}
                Description={description}
                LinkText={linkText}
                LinkTo={  linkTo
                }
                ExternalLinkTo={externalLinkTo}
                id={ButtonConfig.HomeIndcta_mol_hp_vcl}
              />
            )}             
          </Content>
        </div>
        <div
          className={
            "col-sm-12 " + (this.props.shouldShowClaims   ? "col-lg-4" : "col-lg-6")
          }
          data-explore-my-cover-home-card
        >
          <Content
            names={[
              Store.Home.Cards.HomeGPSrc.IconSrc,
              Store.Home.Cards.HomeGPSrc.Heading,
              Store.Home.Cards.HomeGPSrc.Description,
              Store.Home.Cards.HomeGPSrc.LinkText,
              Store.Home.Cards.HomeGPSrc.LinkTo,
              Store.Home.Cards.HomeGPSrc.ExternalLinkTo
            ]}
          >
            {(
              iconSrc,
              heading,
              description,
              linkText,
              linkTo,
              externalLinkTo
            ) => (
              <HomeCard
                IconSrc={iconSrc}
                Heading={heading}
                Description={description}
                LinkText={linkText}
                LinkTo={linkTo}
                ExternalLinkTo={externalLinkTo}
                id={ButtonConfig.HomeIndcta_mol_hp_dh  }
              />
            )}
          </Content>
        </div>
        {/* <div className="row">
                      {(this.props.shouldShowClaims ||
                        this.props.shouldShowUploadDocumentsLink) && (
                        <h2 className="help-links-padding">
                          <Content name={Store.Home.Hero.HelpLinks} />
                        </h2> */}
        {this.props.shouldShowClaims ? (
          <div className="col-sm-12 col-lg-4" data-claims-home-card>
            <Content
              names={[
                Store.Home.Cards.HomeclaimMoneySrc.IconSrc,
                Store.Home.Cards.HomeclaimMoneySrc.Heading,
                Store.Home.Cards.HomeclaimMoneySrc.Description,
                Store.Home.Cards.HomeclaimMoneySrc.LinkText,
                Store.Home.Cards.HomeclaimMoneySrc.LinkTo,
                Store.Home.Cards.HomeclaimMoneySrc.ExternalLinkTo
              ]}
            >
              {(
                iconSrc,
                heading,
                description,
                linkText,
                linkTo,
                externalLinkTo
              ) => (
                <HomeCard
                  IconSrc={iconSrc}
                  Heading={heading}
                  Description={description}
                  LinkText={linkText}
                  LinkTo={linkTo}
                  ExternalLinkTo={externalLinkTo}
                  id={ButtonConfig.HomeIndcta_mol_hp_cp}
                />
              )}
            </Content>
          </div>
        ) : null}
        <div
          className={
            "col-sm-12 " + (this.props.shouldShowClaims ? "col-lg-4" : "col-lg-6")
          }
          data-access-health-support-home-card
        >
          <Content
            names={[
              Store.Home.Cards.HomeTouchSrc.IconSrc,
              Store.Home.Cards.HomeTouchSrc.Heading,
              Store.Home.Cards.HomeTouchSrc.Description,
              Store.Home.Cards.HomeTouchSrc.LinkText,
              Store.Home.Cards.HomeTouchSrc.LinkTo,
              Store.Home.Cards.HomeTouchSrc.ExternalLinkTo
            ]}
          >
            {(
              iconSrc,
              heading,
              description,
              linkText,
              linkTo,
              externalLinkTo
            ) => (
              <HomeCard
                IconSrc={iconSrc}
                Heading={heading}
                Description={description}
                LinkText={linkText}
                LinkTo={  linkTo}
                isDisabled={this.props.IsInternalView}
                ExternalLinkTo={externalLinkTo}
                id={ButtonConfig.HomeIndcta_mol_hp_mess}
              />
            )}
          </Content>
        </div>
      </div>
    );
  }
}

export const mapStateToNewCard = (state) => {
  const { IsLapsed: isLapsed, IsFormat2: isFormat2, IsSME: isSME  } =
    state.policyReducer.selectedPolicy || {};
  return {
    shouldShowClaims: shouldShowIfAllSMEModulesDontMatch(
      state.policyReducer && state.policyReducer.selectedPolicy,
      nonClaimsModules
    ),
    shouldShowUploadDocumentsLink: shouldShowIfAllSMEModulesDontMatch(
      state.policyReducer && state.policyReducer.selectedPolicy,
      travelOrEapModules
    ),
    IsSaga : state.policyReducer.selectedPolicy.IsSaga,
    isLapsed,
    isFormat2,
    isSME,
    IsInternalView: state.policyReducer &&
    state.policyReducer.policyDetails &&
    state.policyReducer.policyDetails.IsInternalView,
  };
};

export default connect(
  mapStateToNewCard
)(NewCard);
